<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="16">
                <el-button :loading="exporting" icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search" :placeholder="$t('common.serialNumber')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="equipmentList" v-loading="loading" class="orders-table tablewithshading" @sort-change="sortEquipment">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <p>
                        <b>{{$t('equipments.customerAddressColon')}}</b>
                        {{props.row.customerAddress}}
                    </p>
                    <p>
                        <b>{{$t('equipments.customerPhoneColon')}}</b>
                        {{props.row.customerPhone}}
                    </p>
                    <p>
                        <b>{{$t('equipments.gasTypeColon')}}</b>
                        {{props.row.gasType}}
                    </p>
                    <p>
                        <b>{{$t('equipments.serviceCompanyColon')}}</b>
                        {{props.row.serviceCompany}}
                    </p>
                    <p>
                        <b>{{$t('equipments.serviceCompanyEmailColon')}}</b>
                        {{props.row.serviceCompanyEmail}}
                    </p>
                    <p>
                        <b>{{$t('equipments.serviceCompanyServiceEmailColon')}}</b>
                        {{props.row.serviceCompanyServiceEmail}}
                    </p>
                    <p>
                        <b>{{$t('equipments.serviceCompanyPartsEmailColon')}}</b>
                        {{props.row.serviceCompanyPartsEmail}}
                    </p>
                    <p>
                        <b>{{$t('equipments.serviceCompanyPhoneColon')}}</b>
                        {{props.row.serviceCompanyPhone}}
                    </p>
                </template>
            </el-table-column>

            <el-table-column prop="model" :label="$t('common.model')"></el-table-column>
            <el-table-column prop="serialNumber" :label="$t('equipments.serial')" sortable="custom"></el-table-column>
            <el-table-column prop="shippingDate" :label="$t('equipments.shippingDate')" sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.shippingDate | date}}
                </template>
            </el-table-column>
            <el-table-column prop="warrantyStart" :label="$t('common.warrantyStart')" sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.warrantyStart | date}}
                </template>
            </el-table-column>
            <el-table-column prop="warrantyEnd" :label="$t('common.warrantyEnd')" sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.warrantyEnd | date}}
                </template>
            </el-table-column>
            <el-table-column prop="customer" :label="$t('common.customer')" sortable="custom"></el-table-column>
            <el-table-column prop="serviceCompany" :label="$t('common.serviceCompany')" sortable="custom"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="160" v-if="$isFullAdmin">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="deleteEquipment(scope.row.id)">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import api from "../api";

    export default {
        name: "equipment-list",
        data() {
            return {
                equipmentList: [],
                loading: true,
                filter: {
                    text: undefined
                },
                sorting: {},
                currentPage: 1,
                total: 0,
                exporting: false
            };
        },
        created() {
            this.loadEquipment();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadEquipment();
                }
            }
        },
        methods: {
            loadEquipment() {
                this.loading = true;
                api.getEquipmentList(this.currentPage, this.filter.text, this.sorting)
                    .then(response => {
                        this.loading = false;
                        this.equipmentList = response.data.items;
                        this.total = response.data.total;
                    });
            },
            sortEquipment(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadEquipment();
                } else {
                    this.currentPage = 1;
                }
            },
            appendEquipment(equipment) {
                this.equipmentList.push(equipment);
                this.total += 1;
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadEquipment();
            },
            deleteEquipment(id) {
                this.$confirm(this.$t('common.thisWillDeleteEquipmentContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteEquipment(id).then(() => {
                            this.loadEquipment();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => { });
            },
            download() {
                this.exporting = true;
                api.download(this.filter.text).then(() => {
                    this.exporting = false;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ClientApp/app/equipment/components/EquipmentList.vue